import { Component } from '@angular/core';

@Component({
  selector: 'custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.css']
})
export class CustomFooterComponent {}
